export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8584.e7897771.jpg";